import { DocumentUploadDropzone } from "@/components/shared/dropzones/document-upload-dropzone";
import { Button } from "@/components/ui/button";
import { InvoiceType } from "@/lib/constants/invoiceStatus";
import { File, Upload } from "lucide-react";

type Props = {
  tenantId: string;
};

export function ReceivablesUploadBox({ tenantId }: Props) {
  return (
    <div className="h-24">
      <DocumentUploadDropzone
        tenantId={tenantId}
        clickUploadEnabled
        invoiceType={InvoiceType.RECEIVABLE}
      >
        {({ isUploading }: { isUploading: boolean }) => (
          <div className="w-full h-full">
            <div className="flex items-center justify-center w-full h-full border-2 border-gray-300 border-dashed rounded-xl cursor-pointer bg-gray-50/80 hover:bg-gray-100/80 transition-colors duration-200 backdrop-blur-sm">
              <div className="flex items-center gap-4">
                <div className="flex items-center gap-2">
                  <Upload className="h-5 w-5 text-gray-700" />
                  <p className="text-sm font-medium text-gray-700">
                    Hier hochladen
                  </p>
                </div>
                <span className="text-sm text-gray-500">oder</span>
                <Button
                  variant="outline"
                  className="h-9 gap-2 bg-white"
                  disabled={isUploading}
                >
                  <File className="h-4 w-4" />
                  {isUploading ? "Wird hochgeladen..." : "Dateien auswählen"}
                </Button>
              </div>
            </div>
          </div>
        )}
      </DocumentUploadDropzone>
    </div>
  );
}
